

























import KeyName from "@/components/KeyName.vue";
import PrefixStatsTabs from "@/components/PrefixStatsTabs.vue";
import PrefixRemove from "@/components/PrefixRemove.vue";
import { Prefix } from "@/types/debug-mode";
import { Component, Vue } from "vue-property-decorator";
import { State, Getter } from "vuex-class";

@Component({
  components: {
    PrefixStatsTabs,
    PrefixRemove,
    KeyName,
  },
})
export default class PrefixView extends Vue {
  created() {
    // Get prefixes, in case of landing on this view directly, or on refresh.
    if (!this.prefixes) {
      this.$store.dispatch("debugMode/fetchPrefixes");
    }
  }

  @State(state => state.debugMode.prefixes) prefixes!: Prefix[] | null;

  @Getter("debugMode/activePrefix") prefix!: Prefix;

  backButtonTitle = "Back to Prefixes";
}
